import type { CityResult, TodayNotificationsResponse } from "@ishvaram/api-client";

import { apiRequest, sameOriginRequest } from "./_fetch";

export type PlaceResult = CityResult;
export type { TodayNotificationsResponse };

// /_places/* is served by the ishvaram-content CF Worker against a D1
// cities table — see business/ishvaram/apps/web/edge-db/worker/places.ts
// and rule 34. Same-origin so no CORS preflight; sub-30ms typical
// response from the user's nearest POP.
export async function searchPlaces(query: string, limit = 8): Promise<PlaceResult[]> {
  if (query.length < 2) return [];
  const params = new URLSearchParams({ q: query, limit: String(limit) });
  try {
    return await sameOriginRequest<PlaceResult[]>(`/_places/autocomplete?${params}`);
  } catch {
    return [];
  }
}

export async function getTodayNotifications(): Promise<TodayNotificationsResponse> {
  return apiRequest<TodayNotificationsResponse>("/transits/notifications/today");
}
